import { all } from "redux-saga/effects";
import CommonApiSaga from "./generators/CommonApiSaga";

function* rootSaga() {
  yield all([...CommonApiSaga]);
}
export default rootSaga;
